module.exports = __webpack_public_path__ + "static/shuffleboard-6bdc72be031aa12411d28b296ed36e05.jpeg";